import { fmtAUD } from "@/shared/utils/formatCurrency";
import { useIsMobile } from "@/shared/hooks/useMediaQuery";

function StatCard({ label, value, color = "#0f172a", sub, theme, currency, compact }) {
  const t = theme;
  return (
    <div
      style={{
        background: t.cardBg,
        borderRadius: 14,
        padding: compact ? 14 : 18,
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
        border: "1px solid " + t.cardBorder,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: t.textMuted,
          textTransform: "uppercase",
          letterSpacing: 0.8,
          marginBottom: compact ? 4 : 6,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: compact ? 20 : 24, fontWeight: 800, color, lineHeight: 1 }}>
        {typeof value === "number" ? currency + fmtAUD(value) : value}
      </div>
      {sub && (
        <div style={{ fontSize: 11, color: t.textMuted, marginTop: 6 }}>
          {sub}
        </div>
      )}
    </div>
  );
}

export default function SummaryCards({
  monthIncome,
  monthExpenses,
  monthNet,
  savingsRate,
  theme,
  currency,
}) {
  const mobile = useIsMobile();
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: mobile ? "repeat(2,1fr)" : "repeat(4,1fr)",
        gap: mobile ? 10 : 14,
        marginBottom: mobile ? 20 : 28,
      }}
    >
      <StatCard
        label="Income"
        value={monthIncome}
        color="#16a34a"
        theme={theme}
        currency={currency}
        compact={mobile}
      />
      <StatCard
        label="Expenses"
        value={monthExpenses}
        color="#ef4444"
        theme={theme}
        currency={currency}
        compact={mobile}
      />
      <StatCard
        label="Net"
        value={monthNet}
        color={monthNet >= 0 ? "#16a34a" : "#ef4444"}
        theme={theme}
        currency={currency}
        compact={mobile}
      />
      <StatCard
        label="Savings Rate"
        value={savingsRate.toFixed(1) + "%"}
        color="#2563eb"
        theme={theme}
        currency={currency}
        compact={mobile}
      />
    </div>
  );
}
